export default "__VITE_ASSET__CRCtB4vi__"